import { Attributes, DateUtils, Misc, Model, Rules, Validation } from '@singularsystems/neo-core';

export default class CustomInvestorInvestmentDetailCriteria extends Model.CriteriaBase {

    constructor() {
        super();
        this.makeObservable();
    }

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public endDate: Date | null = DateUtils.monthEnd(DateUtils.today());

    @Attributes.Nullable()
    public entityId: number | null = null;


    // Client only properties / methods

    protected static addBusinessRules(rules: Validation.Rules<CustomInvestorInvestmentDetailCriteria>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Custom InvestorInvestment Detail Criteria";
    }
}